document.addEventListener('DOMContentLoaded', function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  // hero: swipe slider, dots, autoplay
  document.querySelectorAll('[data-hero]').forEach(function (w) {
    var tr = w.querySelector('.hero-track');
    var n = w.querySelectorAll('.hero-slide').length;
    if (!tr || n < 2) return;
    var dots = document.createElement('div');
    dots.className = 'hero-dots';
    for (var i = 0; i < n; i++) dots.appendChild(document.createElement('span'));
    w.appendChild(dots);
    function mark() {
      var idx = Math.round(tr.scrollLeft / tr.clientWidth);
      Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle('on', k === idx); });
    }
    tr.addEventListener('scroll', mark, { passive: true });
    mark();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduce) {
      var timer = setInterval(function () {
        var end = tr.scrollLeft + tr.clientWidth >= tr.scrollWidth - 5;
        tr.scrollTo({ left: end ? 0 : tr.scrollLeft + tr.clientWidth, behavior: 'smooth' });
      }, 5000);
      w.addEventListener('pointerdown', function () { clearInterval(timer); });
    }
  });

  // saved hearts (stored in this browser only)
  var KEY = 'gm_saved', saved = [];
  try { saved = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { saved = []; }
  function paint(b) {
    var on = saved.indexOf(b.dataset.heart) > -1;
    b.classList.toggle('on', on);
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
  }
  document.querySelectorAll('[data-heart]').forEach(function (b) {
    paint(b);
    b.addEventListener('click', function (e) {
      e.preventDefault();
      var id = b.dataset.heart, i = saved.indexOf(id);
      if (i > -1) saved.splice(i, 1); else saved.push(id);
      try { localStorage.setItem(KEY, JSON.stringify(saved)); } catch (err) {}
      document.querySelectorAll('[data-heart="' + id + '"]').forEach(paint);
    });
  });

  // quick add to cart from product cards
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.classList || !f.classList.contains('card-form')) return;
    e.preventDefault();
    var b = f.querySelector('[data-atc]'), label = b.querySelector('span');
    var old = label.textContent;
    b.disabled = true; label.textContent = 'Adding...';
    fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { return fetch(root + 'cart.js').then(function (r) { return r.json(); }); })
      .then(function (c) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; el.hidden = c.item_count === 0; });
        label.textContent = 'Added';
        setTimeout(function () { label.textContent = old; b.disabled = false; }, 1600);
      })
      .catch(function () { f.submit(); });
  });

  // product page: gallery + variant price
  document.querySelectorAll('[data-product]').forEach(function (p) {
    var main = p.querySelector('[data-main-img]');
    p.querySelectorAll('.thumb').forEach(function (b) {
      b.addEventListener('click', function () {
        if (main) main.src = b.dataset.full;
        p.querySelectorAll('.thumb').forEach(function (x) { x.classList.remove('on'); });
        b.classList.add('on');
      });
    });
    var sel = p.querySelector('[data-variant-select]');
    if (sel) {
      sel.addEventListener('change', function () {
        var o = sel.options[sel.selectedIndex];
        var price = p.querySelector('[data-price]'), cmp = p.querySelector('[data-compare]');
        var off = p.querySelector('[data-off]'), stock = p.querySelector('[data-stock]');
        var add = p.querySelector('[data-add]');
        if (price) price.textContent = o.dataset.price;
        if (cmp) cmp.textContent = o.dataset.compare;
        if (off) { off.textContent = o.dataset.off; off.hidden = !o.dataset.off; }
        var ok = o.dataset.available === 'true';
        if (stock) { stock.textContent = ok ? 'In stock' : 'Currently unavailable'; stock.className = 'stock ' + (ok ? 'in' : 'out'); }
        if (add) add.disabled = !ok;
      });
    }
  });
});
